import { InputNumber, InputNumberProps } from 'antd'

export interface KBInputNumberProps extends InputNumberProps {}

export function KBInputNumber(props: KBInputNumberProps) {
  return <InputNumber size="large" {...props}></InputNumber>
}
